<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>资产列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <el-form :inline="true" :model="search_form" class="demo-form-inline">
          <el-form-item label="关键字">
            <el-input size="small" v-model="search_form.kw" placeholder="支持帐号,域名等模糊搜索"></el-input>
          </el-form-item>
          <el-form-item label="网站分类">
            <el-select
              size="small"
              v-model="search_form.cate_id"
              placeholder="请选择网站分类"
              style="width: 100%;"
            >
              <el-option
                v-for="(item, index) in categories"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="query">查询</el-button>
          </el-form-item>

          <el-form-item class="add">
            <router-link :to="{path:'/means/add'}">
              <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加资产</el-button>
            </router-link>
          </el-form-item>
        </el-form>
      </div>
      <div class="content">
        <el-table border :data="accounts_list">
          <el-table-column prop="domain" label="网站地址" align="center"></el-table-column>
          <el-table-column prop="cate" label="所属分类" align="center"></el-table-column>
          <el-table-column prop="account" label="登录帐号" align="center"></el-table-column>
          <el-table-column label="是否收费" align="center">
            <template slot-scope="scope">{{ scope.row && scope.row.is_pay == 1 ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="price" label="收费价格" align="center"></el-table-column>
          <el-table-column prop="expired_at" label="有效期" align="center"></el-table-column>
          <el-table-column prop="auto_renew" label="自动续费" align="center">
            <template slot-scope="scope">{{ scope.row && scope.row.auto_renew == 1 ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="month" label="续费时长(月)" align="center"></el-table-column>
          <el-table-column prop="remark" label="备注" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <router-link :to="{ path : '/means/update', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>

              <el-button
                type="text"
                @click="seePassword(scope.row)"
                icon="el-icon-view"
              >查看密码</el-button>

              <el-button
                v-if="scope.row.is_del == 0"
                class="success"
                type="text"
                @click="setStatus(scope.row.id)"
                icon="el-icon-setting"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[page_size]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="page_size"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import JSEncrypt from 'jsencrypt'

export default {
  data() {
    return {
      page: 1,
      total: 0,
      page_size: 15,
      accounts_list: [],
      categories: [],
      search_form: {
        cate_id: 0,
        kw: '',
      },
      condition: {},
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getAccounts(this.condition);
    },
    setStatus(id) {
      let _id = id;
      this.$confirm("是否删除当前帐号?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          url: "/accounts/delete",
          data:{
            id: _id,
          },
          type:"POST",
        }).then(res => {
          loading.close()
          this.$util.msg(res.msg, "success");
          setTimeout(() => {
            this.getAccounts();
          }, 1200);
        });
      })
      .catch(() => {});
    },
    getAccounts(condition) {
      this.$ajax({
        url: "/accounts/index",
        data:{
          page: this.page,
          limit: this.pageSize,
          kw: condition.kw || '',
          cate_id: condition.cate_id || 0,
        }
      }).then(data => {
        this.condition = condition;
        this.accounts_list = data.data.data;
        this.total = data.data.total;
      });
    },
    seePassword(account) {
      var save_key = 'access-secret-key-' + account.admin_id;
      
      if(!localStorage.getItem(save_key)) {
        return this.$prompt('密钥', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType:"password",
        }).then(({ value }) => {
          if(!value) {
            return this.$utils.msg('请填写私钥', 'error');
          }

          this.decryptPass(save_key, value, account);
        }).catch(() => {});
      }

      let password = this.decrypt(localStorage.getItem(save_key), account.password);

      if(!password) {
        return this.$util.msg('解密失败，请提供正确的密钥', 'error');
      }

      return this.$alert('您的密码是: ' + password);
    },
    decrypt(private_key, pass) {
      let decrypt = new JSEncrypt(),
          password = '';

      decrypt.setPrivateKey(private_key);

      return decrypt.decrypt(pass);
    },
    decryptPass(save_key, private_key, account) {
      let password = this.decrypt(private_key, account.password);

      if(!password) {
        return this.$util.msg('解密失败，请提供正确的密钥', 'error');
      }
      
      return this.$confirm('您的密码是: ' + password + '，是否信任此浏览器，信任后，将不在输入密钥',"提示", {
        confirmButtonText: "信任",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        localStorage.setItem(save_key, private_key);
        return this.$util.msg('保存成功', 'success');
      }).catch(() => {});
    },
    query() {
      this.page = 1;
      this.getAccounts(this.search_form);
    },
    loadCategory() {
      this.$ajax({
        url: "/constant/category",
      }).then(data => {
        this.categories = [{'id': 0, 'name': '全部'}].concat(data.data);
      });
    },
  },
  mounted() {
    this.loadCategory();
    this.getAccounts(this.search_form);
  },
};
</script>
<style>
  .add{
    float: right;
  }
</style>